import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Nav, NavLink, TabContent, TabPane } from "reactstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import PayNow from "./PayNow";
import Popup from "../Common/Popup/popup";
import { getOrderInvoice, rksCustomerInvoices } from "../../CommonUrl";
import { getClientUrlDataToken } from "../../Utils/restUtils";
import { invoiceOrderColumns, invoicepaidColumns, invoiceUnpaidColumns } from "./ColumnHeader/columnHeader";

const InvoiceTab = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [currentPagePaid, setCurrentPagePaid] = useState(1);
  const [currentPageUnpaid, setCurrentPageUnpaid] = useState(1);
  const [currentPageOrder, setCurrentPageOrder] = useState(1);
  const [perPagePaid, setPerPagePaid] = useState(10);
  const [perPageUnpaid, setPerPageUnpaid] = useState(10);
  const [perPageOrder, setPerPageOrder] = useState(10);
  const [totalRowsPaid, setTotalRowsPaid] = useState(0);
  const [totalRowsUnpaid, setTotalRowsUnpaid] = useState(0);
  const [totalRowsOrder, setTotalRowsOrder] = useState(0);

  const navigate = useNavigate();
  const [modalpay, setmodalPay] = useState(false);
  const [paidInvoiceData, setPaidInvoiceData] = useState();
  const [unpaidInvoiceData, setUnpaidInvoiceData] = useState();
  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const tabTitles = {
    "1": "Unpaid Invoice",
    "2": "Paid Invoice",
    "3": "My Order"
  };

  useEffect(() => {
    fetchDashboardDataPaid();
    fetchDashboardDataUnpaid();
    orderData();
  }, []);

  const handleViewInvoice = (id) => {
    navigate(`/invoice?id=${id}`);
  };

  const handleModalpay = (e) => {
    setmodalPay(!modalpay);
  };

  const handlePayment = (invoiceId) => {
    navigate('/pay', { state: { invoiceId } })
  }

  const handlePageChangeUnpaidInvoice = (page) => {
    setCurrentPageUnpaid(page);
    fetchDashboardDataUnpaid(page, perPageUnpaid);
  };
  const handlePageChangePaidInvoice = (page) => {
    setCurrentPagePaid(page);
    fetchDashboardDataPaid(page, perPagePaid);
  };
  const handlePageChangeOrder = (page) => {
    setCurrentPageOrder(page);
    orderData(page, perPageOrder);
  };

  const handlePerRowsChangeUnpaidInvoice = (newPerPage, page) => {
    setPerPageUnpaid(newPerPage);
    fetchDashboardDataUnpaid(currentPageUnpaid, newPerPage);
  };
  const handlePerRowsChangePaidInvoice = (newPerPage, page) => {
    setPerPagePaid(newPerPage);
    fetchDashboardDataPaid(currentPagePaid, newPerPage);
  };
  const handlePerRowsChangeOrder = (newPerPage, page) => {
    setPerPageOrder(newPerPage);
    orderData(currentPageOrder, newPerPage);
  };
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const fetchDashboardDataPaid = async (page = currentPagePaid, perPage = perPagePaid) => {
    setLoading(true);

    try {
      const paidResponse = await getClientUrlDataToken(
        rksCustomerInvoices + `?payment_status=paid&page=${page}&page_length=${perPage}`
      );


      if (paidResponse?.status) {
        const paidTransactions = paidResponse?.data?.data || [];

        setPaidInvoiceData(paidTransactions);
        setTotalRowsPaid(paidResponse?.data?.total || 0);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching transactions:", error);
    }
  };
  const fetchDashboardDataUnpaid = async (page = currentPageUnpaid, perPage = perPageUnpaid) => {
    setLoading(true);

    try {


      const unpaidResponse = await getClientUrlDataToken(
        rksCustomerInvoices + `?payment_status=unpaid&page=${page}&page_length=${perPage}`
      );

      if (unpaidResponse?.status) {
        const unpaidTransactions = unpaidResponse?.data?.data || [];

        setUnpaidInvoiceData(unpaidTransactions);
        setTotalRowsUnpaid(unpaidResponse?.data?.total || 0);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching transactions:", error);
    }
  };

  const orderData = async (page = currentPageOrder, perPage = perPageOrder) => {
    setLoading(true);
    const data = await getClientUrlDataToken(getOrderInvoice+`?page=${page}&page_length=${perPage}`);

    if (data.status === true) {
      setOrderList(data?.data)
      setLoading(false);
      setTotalRowsOrder(data?.pagination?.total || 0);
    } else if (data.status >= 400 && data.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
    setLoading(false);
  };

  return (
    <div className='container-main' style={{ marginTop: '140px' }}>
      <Card className="height-equals" style={{ margin: '50px 20px 50px 20px', top: '20px' }}>
        <Col sm="12" xl="12 xl-100">
          <Card style={{ marginBottom: '0px' }}>
            <CardHeader className="p-0">
            </CardHeader>
            <CardBody style={{ margin: '10px 30px' }}>
              <h3 className="heading-subtitle" style={{ fontWeight: 'bold', fontSize: '20px', color: '#472e85' }}>Invoice</h3>
              <Nav className="text-primary border-tab nav-primary">
                <NavLink
                  className={`tab-link ${activeTab === "1" ? "active" : ""}`}
                  onClick={() => toggleTab("1")}
                >
                  Unpaid Invoice
                </NavLink>
                <NavLink
                  className={`tab-link ${activeTab === "2" ? "active" : ""}`}
                  onClick={() => toggleTab("2")}
                >
                  Paid Invoice
                </NavLink>
                <NavLink
                  className={`tab-link ${activeTab === "3" ? "active" : ""}`}
                  onClick={() => toggleTab("3")}
                >
                  My Order
                </NavLink>
              </Nav>

              <div className="added-titlerow d-flex justify-content-between align-items-center">
                <div>
                  {tabTitles[activeTab] || "Unknown Tab"}
                </div>
              </div>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <div className="support-history table-responsive">
                    <DataTable
                      columns={invoiceUnpaidColumns(handleViewInvoice, handlePayment, currentPageUnpaid, perPageUnpaid)}
                      data={unpaidInvoiceData || []}
                      pagination
                      paginationServer
                      defaultSortAsc
                      sortServer
                      paginationTotalRows={totalRowsUnpaid}
                      progressPending={loading}
                      paginationRowsPerPageOptions={[10, 25, 50, 100]}
                      paginationDefaultPage={currentPageUnpaid}
                      onChangeRowsPerPage={handlePerRowsChangeUnpaidInvoice}
                      onChangePage={handlePageChangeUnpaidInvoice}
                    />
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="support-history table-responsive">
                    <DataTable
                      columns={invoicepaidColumns(handleViewInvoice, currentPagePaid, perPagePaid)}
                      data={paidInvoiceData || []}
                      pagination
                      paginationServer
                      defaultSortAsc
                      sortServer
                      paginationTotalRows={totalRowsPaid}
                      paginationRowsPerPageOptions={[10, 25, 50, 100]}
                      // paginationTotalRows={paidInvoice.length}
                      progressPending={loading}

                      paginationDefaultPage={currentPagePaid}
                      onChangeRowsPerPage={handlePerRowsChangePaidInvoice}
                      onChangePage={handlePageChangePaidInvoice}
                    />
                  </div>
                </TabPane>
                <TabPane tabId="3">
                  <div className="support-history table-responsive">
                    <DataTable
                      columns={invoiceOrderColumns(handleViewInvoice, currentPageOrder, perPageOrder)}
                      data={orderList}
                      pagination
                      paginationServer
                      defaultSortAsc
                      sortServer
                      progressPending={loading}
                      paginationTotalRows={totalRowsOrder}
                      paginationRowsPerPageOptions={[10, 25, 50, 100]}
                      paginationDefaultPage={currentPageOrder}
                      onChangeRowsPerPage={handlePerRowsChangeOrder}
                      onChangePage={handlePageChangeOrder}
                    />
                  </div>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Col>

        <Popup isOpen={modalpay} toggler={handleModalpay}>
          <PayNow
            unPaidInvoice={unpaidInvoiceData}
          />
        </Popup>
      </Card>
    </div>
  );
};

export default InvoiceTab;
